export const aboutData = {
    title: "Full Stack Web Developer",
    description1: "My name's Amarjeet. I'm a web designer and developer based in Azamgarh, IN.",
    description2: "During the day I work as a Tech support at a Richpanel and in the evening I learn full stack web development from Masai utilize the time to learn more about Web development. I spent my leisure hours reading and traveling. Right now I'm also trying a hand at machine learning and AI. I love to learn and explore new arenas.",
    image: 1
}